__turbopack_context__.v({
  "chart": "BlockCommitmentChart-module-scss-module__vyb2Ya__chart",
  "chartHeadline": "BlockCommitmentChart-module-scss-module__vyb2Ya__chartHeadline",
  "chartInner": "BlockCommitmentChart-module-scss-module__vyb2Ya__chartInner",
  "chartRow": "BlockCommitmentChart-module-scss-module__vyb2Ya__chartRow",
  "commitmentChart": "BlockCommitmentChart-module-scss-module__vyb2Ya__commitmentChart",
  "contentWrapper": "BlockCommitmentChart-module-scss-module__vyb2Ya__contentWrapper",
  "copy": "BlockCommitmentChart-module-scss-module__vyb2Ya__copy",
  "copyWrapper": "BlockCommitmentChart-module-scss-module__vyb2Ya__copyWrapper",
  "draggableChart": "BlockCommitmentChart-module-scss-module__vyb2Ya__draggableChart",
  "flushBottom": "BlockCommitmentChart-module-scss-module__vyb2Ya__flushBottom",
  "flushTop": "BlockCommitmentChart-module-scss-module__vyb2Ya__flushTop",
  "headline": "BlockCommitmentChart-module-scss-module__vyb2Ya__headline",
  "imgBlock": "BlockCommitmentChart-module-scss-module__vyb2Ya__imgBlock",
  "innerChart": "BlockCommitmentChart-module-scss-module__vyb2Ya__innerChart",
  "innerWrapper": "BlockCommitmentChart-module-scss-module__vyb2Ya__innerWrapper",
  "lockup": "BlockCommitmentChart-module-scss-module__vyb2Ya__lockup",
  "standardIcon": "BlockCommitmentChart-module-scss-module__vyb2Ya__standardIcon",
  "standardIconWrapper": "BlockCommitmentChart-module-scss-module__vyb2Ya__standardIconWrapper",
  "standardWrapper": "BlockCommitmentChart-module-scss-module__vyb2Ya__standardWrapper",
  "standardsHeadline": "BlockCommitmentChart-module-scss-module__vyb2Ya__standardsHeadline",
  "standardsList": "BlockCommitmentChart-module-scss-module__vyb2Ya__standardsList",
});
